import React from 'react'
import CartItems from '../Components/CartItems/CartItems'

const Cart = () => {
  return (
    <div className='cart'>
      <CartItems />
    </div>
  )
}

export default Cart